// @generated by protoc-gen-es v1.8.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/chat/message_payload.proto (package qliq_protobuf.chat, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { GptConfigDataResponse } from "../gpt_config_data_response_pb.ts";
import { MessageFile } from "./message_file_pb.ts";

/**
 * @generated from message qliq_protobuf.chat.MessagePayload
 */
export class MessagePayload extends Message<MessagePayload> {
  /**
   * @generated from oneof qliq_protobuf.chat.MessagePayload.content
   */
  content: {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.BotPayload bot_payload = 1;
     */
    value: MessagePayload_BotPayload;
    case: "botPayload";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.UserPayload user_payload = 2;
     */
    value: MessagePayload_UserPayload;
    case: "userPayload";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<MessagePayload>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bot_payload", kind: "message", T: MessagePayload_BotPayload, oneof: "content" },
    { no: 2, name: "user_payload", kind: "message", T: MessagePayload_UserPayload, oneof: "content" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload {
    return new MessagePayload().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload {
    return new MessagePayload().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload {
    return new MessagePayload().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload | PlainMessage<MessagePayload> | undefined, b: MessagePayload | PlainMessage<MessagePayload> | undefined): boolean {
    return proto3.util.equals(MessagePayload, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.chat.MessagePayload.InputType
 */
export enum MessagePayload_InputType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: INTENT = 1;
   */
  INTENT = 1,

  /**
   * @generated from enum value: NAME = 2;
   */
  NAME = 2,

  /**
   * @generated from enum value: LAST_NAME = 3;
   */
  LAST_NAME = 3,

  /**
   * @generated from enum value: FIRST_NAME = 4;
   */
  FIRST_NAME = 4,

  /**
   * @generated from enum value: PHONE = 5;
   */
  PHONE = 5,

  /**
   * @generated from enum value: EMAIL = 6;
   */
  EMAIL = 6,

  /**
   * @generated from enum value: DATE = 7;
   */
  DATE = 7,

  /**
   * @generated from enum value: TIME_DAY = 8;
   */
  TIME_DAY = 8,

  /**
   * @generated from enum value: DATE_OF_BIRTH = 9;
   */
  DATE_OF_BIRTH = 9,

  /**
   * @generated from enum value: LOCATION = 10;
   */
  LOCATION = 10,

  /**
   * @generated from enum value: PAIN_SCALE = 11;
   */
  PAIN_SCALE = 11,

  /**
   * @generated from enum value: CUSTOM = 12;
   */
  CUSTOM = 12,
}
// Retrieve enum metadata with: proto3.getEnumType(MessagePayload_InputType)
proto3.util.setEnumType(MessagePayload_InputType, "qliq_protobuf.chat.MessagePayload.InputType", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "INTENT" },
  { no: 2, name: "NAME" },
  { no: 3, name: "LAST_NAME" },
  { no: 4, name: "FIRST_NAME" },
  { no: 5, name: "PHONE" },
  { no: 6, name: "EMAIL" },
  { no: 7, name: "DATE" },
  { no: 8, name: "TIME_DAY" },
  { no: 9, name: "DATE_OF_BIRTH" },
  { no: 10, name: "LOCATION" },
  { no: 11, name: "PAIN_SCALE" },
  { no: 12, name: "CUSTOM" },
]);

/**
 * @generated from enum qliq_protobuf.chat.MessagePayload.CustomType
 */
export enum MessagePayload_CustomType {
  /**
   * @generated from enum value: ISABEL_COUNTRY = 0;
   */
  ISABEL_COUNTRY = 0,

  /**
   * @generated from enum value: ISABEL_SYMPTOMS = 1;
   */
  ISABEL_SYMPTOMS = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(MessagePayload_CustomType)
proto3.util.setEnumType(MessagePayload_CustomType, "qliq_protobuf.chat.MessagePayload.CustomType", [
  { no: 0, name: "ISABEL_COUNTRY" },
  { no: 1, name: "ISABEL_SYMPTOMS" },
]);

/**
 * @generated from enum qliq_protobuf.chat.MessagePayload.SignOffAction
 */
export enum MessagePayload_SignOffAction {
  /**
   * @generated from enum value: END_CONVERSATION = 0;
   */
  END_CONVERSATION = 0,

  /**
   * @generated from enum value: NATURAL_ESCALATION = 1;
   */
  NATURAL_ESCALATION = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(MessagePayload_SignOffAction)
proto3.util.setEnumType(MessagePayload_SignOffAction, "qliq_protobuf.chat.MessagePayload.SignOffAction", [
  { no: 0, name: "END_CONVERSATION" },
  { no: 1, name: "NATURAL_ESCALATION" },
]);

/**
 * @generated from enum qliq_protobuf.chat.MessagePayload.Command
 */
export enum MessagePayload_Command {
  /**
   * @generated from enum value: EXIT_IFRAME = 0;
   */
  EXIT_IFRAME = 0,
}
// Retrieve enum metadata with: proto3.getEnumType(MessagePayload_Command)
proto3.util.setEnumType(MessagePayload_Command, "qliq_protobuf.chat.MessagePayload.Command", [
  { no: 0, name: "EXIT_IFRAME" },
]);

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.UserChoice
 */
export class MessagePayload_UserChoice extends Message<MessagePayload_UserChoice> {
  /**
   * @generated from field: string locale = 1;
   */
  locale = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  /**
   * @generated from field: string image_url = 3;
   */
  imageUrl = "";

  /**
   * @generated from field: string payload = 4;
   */
  payload = "";

  constructor(data?: PartialMessage<MessagePayload_UserChoice>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.UserChoice";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_UserChoice {
    return new MessagePayload_UserChoice().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_UserChoice {
    return new MessagePayload_UserChoice().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_UserChoice {
    return new MessagePayload_UserChoice().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_UserChoice | PlainMessage<MessagePayload_UserChoice> | undefined, b: MessagePayload_UserChoice | PlainMessage<MessagePayload_UserChoice> | undefined): boolean {
    return proto3.util.equals(MessagePayload_UserChoice, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.Faq
 */
export class MessagePayload_Faq extends Message<MessagePayload_Faq> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: bool is_auto_expand_faq = 3;
   */
  isAutoExpandFaq = false;

  /**
   * @generated from field: string question = 4;
   */
  question = "";

  constructor(data?: PartialMessage<MessagePayload_Faq>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.Faq";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_auto_expand_faq", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_Faq {
    return new MessagePayload_Faq().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_Faq {
    return new MessagePayload_Faq().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_Faq {
    return new MessagePayload_Faq().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_Faq | PlainMessage<MessagePayload_Faq> | undefined, b: MessagePayload_Faq | PlainMessage<MessagePayload_Faq> | undefined): boolean {
    return proto3.util.equals(MessagePayload_Faq, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.Form
 */
export class MessagePayload_Form extends Message<MessagePayload_Form> {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid = "";

  constructor(data?: PartialMessage<MessagePayload_Form>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.Form";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_Form {
    return new MessagePayload_Form().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_Form {
    return new MessagePayload_Form().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_Form {
    return new MessagePayload_Form().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_Form | PlainMessage<MessagePayload_Form> | undefined, b: MessagePayload_Form | PlainMessage<MessagePayload_Form> | undefined): boolean {
    return proto3.util.equals(MessagePayload_Form, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.Media
 */
export class MessagePayload_Media extends Message<MessagePayload_Media> {
  /**
   * @generated from field: optional string filename = 1;
   */
  filename?: string;

  /**
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * @generated from field: optional uint32 size = 3;
   */
  size?: number;

  /**
   * @generated from field: bool is_thumbnail_shown = 5;
   */
  isThumbnailShown = false;

  constructor(data?: PartialMessage<MessagePayload_Media>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.Media";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "size", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 5, name: "is_thumbnail_shown", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_Media {
    return new MessagePayload_Media().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_Media {
    return new MessagePayload_Media().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_Media {
    return new MessagePayload_Media().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_Media | PlainMessage<MessagePayload_Media> | undefined, b: MessagePayload_Media | PlainMessage<MessagePayload_Media> | undefined): boolean {
    return proto3.util.equals(MessagePayload_Media, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.Scheduler
 */
export class MessagePayload_Scheduler extends Message<MessagePayload_Scheduler> {
  /**
   * @generated from field: string resource_uuid = 1;
   */
  resourceUuid = "";

  /**
   * @generated from field: string scheduler_type = 2;
   */
  schedulerType = "";

  constructor(data?: PartialMessage<MessagePayload_Scheduler>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.Scheduler";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scheduler_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_Scheduler {
    return new MessagePayload_Scheduler().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_Scheduler {
    return new MessagePayload_Scheduler().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_Scheduler {
    return new MessagePayload_Scheduler().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_Scheduler | PlainMessage<MessagePayload_Scheduler> | undefined, b: MessagePayload_Scheduler | PlainMessage<MessagePayload_Scheduler> | undefined): boolean {
    return proto3.util.equals(MessagePayload_Scheduler, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.UserInput
 */
export class MessagePayload_UserInput extends Message<MessagePayload_UserInput> {
  /**
   * @generated from field: qliq_protobuf.chat.MessagePayload.InputType type = 1;
   */
  type = MessagePayload_InputType.UNKNOWN;

  /**
   * @generated from field: qliq_protobuf.chat.MessagePayload.CustomType custom_type = 2;
   */
  customType = MessagePayload_CustomType.ISABEL_COUNTRY;

  /**
   * @generated from field: bool is_geolocation_disabled = 3;
   */
  isGeolocationDisabled = false;

  /**
   * @generated from field: bool is_standard_time = 4;
   */
  isStandardTime = false;

  constructor(data?: PartialMessage<MessagePayload_UserInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.UserInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(MessagePayload_InputType) },
    { no: 2, name: "custom_type", kind: "enum", T: proto3.getEnumType(MessagePayload_CustomType) },
    { no: 3, name: "is_geolocation_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_standard_time", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_UserInput {
    return new MessagePayload_UserInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_UserInput {
    return new MessagePayload_UserInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_UserInput {
    return new MessagePayload_UserInput().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_UserInput | PlainMessage<MessagePayload_UserInput> | undefined, b: MessagePayload_UserInput | PlainMessage<MessagePayload_UserInput> | undefined): boolean {
    return proto3.util.equals(MessagePayload_UserInput, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.ThirdPartyIntegration
 */
export class MessagePayload_ThirdPartyIntegration extends Message<MessagePayload_ThirdPartyIntegration> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: string payload = 2;
   */
  payload = "";

  /**
   * @generated from field: bool is_sync = 3;
   */
  isSync = false;

  constructor(data?: PartialMessage<MessagePayload_ThirdPartyIntegration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.ThirdPartyIntegration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_sync", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_ThirdPartyIntegration {
    return new MessagePayload_ThirdPartyIntegration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_ThirdPartyIntegration {
    return new MessagePayload_ThirdPartyIntegration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_ThirdPartyIntegration {
    return new MessagePayload_ThirdPartyIntegration().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_ThirdPartyIntegration | PlainMessage<MessagePayload_ThirdPartyIntegration> | undefined, b: MessagePayload_ThirdPartyIntegration | PlainMessage<MessagePayload_ThirdPartyIntegration> | undefined): boolean {
    return proto3.util.equals(MessagePayload_ThirdPartyIntegration, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.MultiChoice
 */
export class MessagePayload_MultiChoice extends Message<MessagePayload_MultiChoice> {
  /**
   * @generated from field: repeated qliq_protobuf.chat.MessagePayload.UserChoice choices = 1;
   */
  choices: MessagePayload_UserChoice[] = [];

  constructor(data?: PartialMessage<MessagePayload_MultiChoice>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.MultiChoice";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "choices", kind: "message", T: MessagePayload_UserChoice, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_MultiChoice {
    return new MessagePayload_MultiChoice().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_MultiChoice {
    return new MessagePayload_MultiChoice().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_MultiChoice {
    return new MessagePayload_MultiChoice().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_MultiChoice | PlainMessage<MessagePayload_MultiChoice> | undefined, b: MessagePayload_MultiChoice | PlainMessage<MessagePayload_MultiChoice> | undefined): boolean {
    return proto3.util.equals(MessagePayload_MultiChoice, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.RtcSession
 */
export class MessagePayload_RtcSession extends Message<MessagePayload_RtcSession> {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId = "";

  constructor(data?: PartialMessage<MessagePayload_RtcSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.RtcSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "room_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_RtcSession {
    return new MessagePayload_RtcSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_RtcSession {
    return new MessagePayload_RtcSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_RtcSession {
    return new MessagePayload_RtcSession().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_RtcSession | PlainMessage<MessagePayload_RtcSession> | undefined, b: MessagePayload_RtcSession | PlainMessage<MessagePayload_RtcSession> | undefined): boolean {
    return proto3.util.equals(MessagePayload_RtcSession, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.Gpt
 */
export class MessagePayload_Gpt extends Message<MessagePayload_Gpt> {
  /**
   * @generated from field: optional qliq_protobuf.GptConfigDataResponse config_data_response = 1;
   */
  configDataResponse?: GptConfigDataResponse;

  constructor(data?: PartialMessage<MessagePayload_Gpt>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.Gpt";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "config_data_response", kind: "message", T: GptConfigDataResponse, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_Gpt {
    return new MessagePayload_Gpt().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_Gpt {
    return new MessagePayload_Gpt().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_Gpt {
    return new MessagePayload_Gpt().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_Gpt | PlainMessage<MessagePayload_Gpt> | undefined, b: MessagePayload_Gpt | PlainMessage<MessagePayload_Gpt> | undefined): boolean {
    return proto3.util.equals(MessagePayload_Gpt, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.BotPayload
 */
export class MessagePayload_BotPayload extends Message<MessagePayload_BotPayload> {
  /**
   * @generated from oneof qliq_protobuf.chat.MessagePayload.BotPayload.option
   */
  option: {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.Faq faq = 1;
     */
    value: MessagePayload_Faq;
    case: "faq";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.Form form = 2;
     */
    value: MessagePayload_Form;
    case: "form";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.Media media = 3;
     */
    value: MessagePayload_Media;
    case: "media";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.Scheduler scheduler_data = 4;
     */
    value: MessagePayload_Scheduler;
    case: "schedulerData";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.UserInput input = 5;
     */
    value: MessagePayload_UserInput;
    case: "input";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.ThirdPartyIntegration docusign = 6;
     */
    value: MessagePayload_ThirdPartyIntegration;
    case: "docusign";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.ThirdPartyIntegration emr_sync = 7;
     */
    value: MessagePayload_ThirdPartyIntegration;
    case: "emrSync";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.MultiChoice quick_reply = 8;
     */
    value: MessagePayload_MultiChoice;
    case: "quickReply";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.MultiChoice carousel = 9;
     */
    value: MessagePayload_MultiChoice;
    case: "carousel";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.MultiChoice sign_off = 10;
     */
    value: MessagePayload_MultiChoice;
    case: "signOff";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.Command command = 11;
     */
    value: MessagePayload_Command;
    case: "command";
  } | {
    /**
     * @generated from field: qliq_protobuf.MessageFile file = 12;
     */
    value: MessageFile;
    case: "file";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.MultiChoice payment_reply = 13;
     */
    value: MessagePayload_MultiChoice;
    case: "paymentReply";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.Gpt gpt = 14;
     */
    value: MessagePayload_Gpt;
    case: "gpt";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: optional bool autoplay = 15;
   */
  autoplay?: boolean;

  constructor(data?: PartialMessage<MessagePayload_BotPayload>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.BotPayload";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "faq", kind: "message", T: MessagePayload_Faq, oneof: "option" },
    { no: 2, name: "form", kind: "message", T: MessagePayload_Form, oneof: "option" },
    { no: 3, name: "media", kind: "message", T: MessagePayload_Media, oneof: "option" },
    { no: 4, name: "scheduler_data", kind: "message", T: MessagePayload_Scheduler, oneof: "option" },
    { no: 5, name: "input", kind: "message", T: MessagePayload_UserInput, oneof: "option" },
    { no: 6, name: "docusign", kind: "message", T: MessagePayload_ThirdPartyIntegration, oneof: "option" },
    { no: 7, name: "emr_sync", kind: "message", T: MessagePayload_ThirdPartyIntegration, oneof: "option" },
    { no: 8, name: "quick_reply", kind: "message", T: MessagePayload_MultiChoice, oneof: "option" },
    { no: 9, name: "carousel", kind: "message", T: MessagePayload_MultiChoice, oneof: "option" },
    { no: 10, name: "sign_off", kind: "message", T: MessagePayload_MultiChoice, oneof: "option" },
    { no: 11, name: "command", kind: "enum", T: proto3.getEnumType(MessagePayload_Command), oneof: "option" },
    { no: 12, name: "file", kind: "message", T: MessageFile, oneof: "option" },
    { no: 13, name: "payment_reply", kind: "message", T: MessagePayload_MultiChoice, oneof: "option" },
    { no: 14, name: "gpt", kind: "message", T: MessagePayload_Gpt, oneof: "option" },
    { no: 15, name: "autoplay", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_BotPayload {
    return new MessagePayload_BotPayload().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_BotPayload {
    return new MessagePayload_BotPayload().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_BotPayload {
    return new MessagePayload_BotPayload().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_BotPayload | PlainMessage<MessagePayload_BotPayload> | undefined, b: MessagePayload_BotPayload | PlainMessage<MessagePayload_BotPayload> | undefined): boolean {
    return proto3.util.equals(MessagePayload_BotPayload, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.ChoicePayload
 */
export class MessagePayload_ChoicePayload extends Message<MessagePayload_ChoicePayload> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<MessagePayload_ChoicePayload>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.ChoicePayload";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_ChoicePayload {
    return new MessagePayload_ChoicePayload().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_ChoicePayload {
    return new MessagePayload_ChoicePayload().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_ChoicePayload {
    return new MessagePayload_ChoicePayload().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_ChoicePayload | PlainMessage<MessagePayload_ChoicePayload> | undefined, b: MessagePayload_ChoicePayload | PlainMessage<MessagePayload_ChoicePayload> | undefined): boolean {
    return proto3.util.equals(MessagePayload_ChoicePayload, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.MessagePayload.UserPayload
 */
export class MessagePayload_UserPayload extends Message<MessagePayload_UserPayload> {
  /**
   * @generated from oneof qliq_protobuf.chat.MessagePayload.UserPayload.option
   */
  option: {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.SignOffAction sign_off_action = 1;
     */
    value: MessagePayload_SignOffAction;
    case: "signOffAction";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.RtcSession rtc_session = 2;
     */
    value: MessagePayload_RtcSession;
    case: "rtcSession";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.MessagePayload.ChoicePayload choice_payload = 3;
     */
    value: MessagePayload_ChoicePayload;
    case: "choicePayload";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<MessagePayload_UserPayload>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.MessagePayload.UserPayload";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sign_off_action", kind: "enum", T: proto3.getEnumType(MessagePayload_SignOffAction), oneof: "option" },
    { no: 2, name: "rtc_session", kind: "message", T: MessagePayload_RtcSession, oneof: "option" },
    { no: 3, name: "choice_payload", kind: "message", T: MessagePayload_ChoicePayload, oneof: "option" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MessagePayload_UserPayload {
    return new MessagePayload_UserPayload().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MessagePayload_UserPayload {
    return new MessagePayload_UserPayload().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MessagePayload_UserPayload {
    return new MessagePayload_UserPayload().fromJsonString(jsonString, options);
  }

  static equals(a: MessagePayload_UserPayload | PlainMessage<MessagePayload_UserPayload> | undefined, b: MessagePayload_UserPayload | PlainMessage<MessagePayload_UserPayload> | undefined): boolean {
    return proto3.util.equals(MessagePayload_UserPayload, a, b);
  }
}

